import { cn } from '@core/utils';

interface DesktopPageShellProps {
  children: React.ReactNode;
  leftAside?: React.ReactNode;
  rightAside?: React.ReactNode;
  className?: string;
  mainClassName?: string;
  variant?: 'rail' | 'wide';
}

const MAIN_VARIANT_CLASS = {
  rail: 'xl:w-[600px] xl:shrink-0',
  wide: 'xl:min-w-0 xl:flex-1',
} as const;

export const DesktopPageShell = ({
  children,
  leftAside,
  rightAside,
  className,
  mainClassName,
  variant = 'rail',
}: DesktopPageShellProps) => {
  return (
    <div
      className={cn(
        'mx-auto flex w-full max-w-screen-xl flex-col xl:flex-row xl:items-start xl:justify-center xl:gap-24',
        className,
      )}
    >
      {leftAside}
      <div
        className={cn(
          'w-full min-w-0',
          MAIN_VARIANT_CLASS[variant],
          mainClassName,
        )}
      >
        {children}
      </div>
      {rightAside}
    </div>
  );
};
